// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1IeFh","title":"ClientReferral_title__chv4v","itemText":"ClientReferral_itemText___pr44"};